import { services } from '../services';
var action = "commissiontype";

export const commissiontypeService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getPaymentType,
    getCommissionTypeFor
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getPaymentType() {
    return services.restApi(`paymenttype`, 'GET');
}

function getCommissionTypeFor() {
    return services.restApi(`commissiontypefor`, 'GET');
}